import PageLoader from '@/common/service/flow/page-loader';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import {
  loadSelectByPersist,
  plansDataMapper,
  filterCapacity,
  loadByShoppingCart,
  loadSelectByPersistAfterSwitch,
} from '@/common/service/plan-data-mapper';
import { buySubscription, freeUpgrade, capacityConfig, purchasePlan, getPastList } from '@/apis';
import { getAccountFreeTrialPlans, getAccountSubscriptions } from '@/common/service/base-paid';
import { pollingEventStatus } from '@/common/polling';
import store from '@/store/index';
import _, { cloneDeep, includes, filter, find, get } from 'lodash';
import { modalHybrid } from '@/utils/modal-utils.js';
import {
  billingConfig$Cache,
  getPreAssignPhoneNumber,
  gotoSuccessPage,
  gotoTrialSuccessPage,
  gotoWiseSuccessPage,
  upgradeSuccessPage,
} from '@/common/service/common';
import {
  loadDefaultPlansByCartId,
  loadDefaultPlansByPreloadCoupon,
  preloadWithNoActiveCouponCampaignUtils,
} from '@/views/config/coupon/helper/preload';
import { isEmptyVal } from '@/utils';
import {
  planQueryParser,
  addToCartByCategoryAndBillingCycle,
  addToCartByType,
  getAudioCountriesParams,
  addToCart,
  getTargetUserIdParam,
} from '@/common/service/flow/utils';
import { preCheckForPbx } from '@/common/service/validate/pbx';
import { regionTypesEnum } from '@/views/checkout/constant';
import { preCheckPartnerRefer } from '@/views/config/partner-refer/helper/validator';
import { loadDefaultPlansByPartnerReferral } from '@/views/config/partner-refer/helper/preload';
import { getPlanTypeByCategory } from '@/common/service/parse';
import {
  AccountType,
  BASE_PLAN_SUB_TYPES,
  BILLING_CYCLE,
  ZOOM_MEETING_PRO_MIN_LICENSE,
  planTypes,
  ZOOM_EDUCATION_INDIVIDUAL_PLAN_TYPES,
  ZOOM_EDUCATION_OPTIONAL_PLAN_TYPES,
  PLAN_UPGRADE_BIZ_TYPE,
  PBX_CATEGORYS,
  ABANDON_CART_EMAIL_COOKIE_KEY,
  ZOOM_MEETING_EDU_PLUS_MIN_LICENSE,
  WEBINAR_ONE_TIME_CAPACITY,
  VIEWS,
  EventSaasCoreConsumptionOverageCategory,
  EventSaasConsumptionOverageCategory,
  baseMeetingTypeList, BUNDLE_WITH_ZP_BASE_PLAN_TYPES,
  ZONE_BASIC_PLUS_CATEGORIES,
} from '@/common/constants';
import { beforeCheckForCoupon, beforeInitPageCheckForCoupon } from '@/views/config/coupon/helper/validator';
import Flow from '@/flows/flow';
import {
  addBasePlanByTargetAddonPlan,
  addBasePlanToStandAlone,
  addDependBasePlan,
  addWebinarOneTimePsoRelatedPlan,
} from '@/common/product';
import { removeEmptyValue, addParamsIfNeedUseVerification } from '@/common/service/checkout-utils';
import { checkCountriesRegionsOption } from '@/common/service/validate/tollfree';
import { APM, WISE } from '@/views/checkout/payment/helper/constant';
import { isBizPlusContext, isEduSchCmpPlusContext, isProPlusContext } from '@/plans/ZOOM_MEETING/common/utils';
import { checkBizPlusLicensePromise, zoneBundleUtils } from '@/plans/ZOOM_ONE_BUNDLE/utils';
import { checkZoneEduPlusLicense } from '@/plans/ZONE_EDU_PLUS/utils';
import { preCheckZoneProPlusForBuyNow } from '@/plans/ZONE_PRO_PLUS/utils/validator';
import { freeTrialIneligibleCheck } from '../BUY_TRIAL/index';
import { getPartnershipParams } from '@/views/config/partner-refer/helper/params';
import {
  computedCallingPlans,
  computedPbxBasePlans, computedPbxMeteredPlans,
  computedUnlimitedCallingPlans, PBX_SUB_TYPES,
} from '@/common/service/computers/plans/pbx';
import { getDefaultEcmInfo, lockAndCancelTaxApi } from '@/apis/tax';
import { getLookupRouterParams } from '@/common/service/lookup-params';
import { ZOOM_MEETING_SUB_TYPES } from '../../plans/ZOOM_MEETING/common/utils';
import { simulateSingleUseProPlan } from '@/common/service/single-use';
import { webinarSingleUseAllowed } from '@/common/service/op-switch';
import { generateOnSessionSignature } from '@/apis/payment';
import { getOrderSummaryFields } from '../utils';
import { plansof } from '@/utils/chain';
import BillingMessageBox from "@/components/common/message-box";
import { translation } from '@/plugins/i18n';
import { formJump } from '@/common/utils';
import { getOpenInvoiceState } from '@/views/config/shopping-cart/open-invoice/helper';
import { isFromMarketingCampaign } from '@/views/config/coupon/helper/utils';
import { successTempEventStatus } from '@/common/service/temp-flow-data';
import { isOnlineFreeTrailAccountBySubscriptions } from '@/store/modules/shopping-cart';
import { getAllProductInfo } from '@/flows/helper/get-plans-data';
import { addVendorProduct } from '../helper/vendor-product';
import { US_short } from '@/common/regionUtils';
import Enums from '@/common/enums/Enums';
import { logger } from '@/utils/log';

const TRIAL_SUCCESS_CODE = 'freetrial_success';

const checkSelectedPlan = (planMapFlat = []) => {
  return planMapFlat.find((item) => item.cartInfo.selected_number > 0);
};

function loadWinbackByQuery(planMapFlat) {
  const { init_categories, period = BILLING_CYCLE.ANNUAL } = pageConfig;
  const categories = init_categories.split(';');
  categories.forEach((categoryStr) => {
    const { fromType, category_codes } = planQueryParser(categoryStr);
    category_codes.forEach((category) => {
      let quantity_ = 1;
      if (zoneBundleUtils.isBizPlusByCategory(category)) quantity_ = ZOOM_MEETING_PRO_MIN_LICENSE;
      if (zoneBundleUtils.isEduPlusByCategory(category)) quantity_ = ZOOM_MEETING_EDU_PLUS_MIN_LICENSE;
      addToCartByCategoryAndBillingCycle(planMapFlat, fromType, category, period, quantity_);
    });
  });
  const pbxSelectedPlans = planMapFlat
    .filter((item) => item.cartInfo.selected_number > 0)
    .filter((item) =>
      [
        planTypes.ZOOM_PHONE,
        planTypes.ZOOM_PHONE$ZPA,
        planTypes.ZOOM_PHONE$ZPI,
        planTypes.ZONE_PRO_PLUS,
        planTypes.ZOOM_ONE_BUNDLE,
        planTypes.ZONE_EDU_PLUS,
      ].includes(item.type),
    );
  const pbxBasePlans = computedPbxBasePlans(pbxSelectedPlans);
  const callingPlans = computedCallingPlans(pbxSelectedPlans);
  if (pbxSelectedPlans.length > 0 && !pbxBasePlans.length) {
    // Don't have pbx base plan
    addToCartByCategoryAndBillingCycle(planMapFlat, planTypes.ZOOM_PHONE, PBX_CATEGORYS.ZVP, period);
  }
  if (pbxSelectedPlans.length > 0 && !callingPlans.length) {
    // Don't have pbx calling plan
    addToCartByCategoryAndBillingCycle(planMapFlat, planTypes.ZOOM_PHONE, 'ZVU', period);
  }
  return planMapFlat;
}

export const requestPastPlans = async (planMapFlat,subscriptions) => {
  const { initialPlanCodes } = store.getters;
  const { from, plan } = pageConfig;
  const videoSDKList = ['litesdk', 'zsdkuc'];
  //Cannot purchase and other processes
  const isVideoSdkFlow = videoSDKList.includes(plan);
  const isNotBasicPlus = !ZONE_BASIC_PLUS_CATEGORIES.includes(plan);
  //freeWithCC、no client modal、no freeTrail、no bizPlus、clipplus、avatar flow.
  let isRequest =isNotBasicPlus && !isVideoSdkFlow && ![AccountType.ACCOUNT_UNKNOWN, AccountType.ACCOUNT_FREE_WITHOUT_CC].includes(pageConfig.accountType) && !modalHybrid.isInWebview && !isOnlineFreeTrailAccountBySubscriptions(subscriptions) && !isBizPlusContext && initialPlanCodes.length > 0 && !isFromMarketingCampaign() && ![planTypes.ZOOM_CLIPS, 'zclips', planTypes.CUSTOM_AVATARS].includes(from);
  const { result } = await (isRequest ? getPastList({ planCodesInCart: initialPlanCodes.join(',') }) : Promise.resolve({ result: [] }));
  if (!result || result.length === 0) {
    return [];
  }
  function getPastPlansWithSemanticType(data) {
    return data.map((item) => {
      let semanticType = '';

      if (EventSaasCoreConsumptionOverageCategory === item.planCode) {
        semanticType = planTypes[planTypes.EVENT_SAAS_CORE];
      } else if (EventSaasConsumptionOverageCategory === item.planCode) {
        semanticType = planTypes[planTypes.EVENT_SAAS];
      } else {
        semanticType =
          planTypes[plansof(planMapFlat).code(item.planCode).get(0)?.type] ||
          planTypes[getPlanTypeByCategory(item.type)] ||
          planTypes[getPlanTypeByCategory(item.categoryCode.toLowerCase())];
      }

      return {
        ...item,
        semanticType,
      };
    }).filter(item => item.semanticType);
  }

  let pastPlans = getPastPlansWithSemanticType(result);
  const initialPlans = planMapFlat.filter(item => store.getters.initialPlanCodes.includes(item.originPlanCode || item.plan_code));
  //zp and bundlePlan cannot exist at the same time
  let isZoomPhoneInitial = false;
  let isBundleInitial = false;
  for (const item of initialPlans) {
    if (
      item.type === planTypes.ZOOM_PHONE &&
      item.billing_cycle !== BILLING_CYCLE.PAY_AS_YOU_GO
    ) {
      isZoomPhoneInitial = true;
    }
    if (BUNDLE_WITH_ZP_BASE_PLAN_TYPES.includes(item.type)) {
      isBundleInitial = true;
    }
    if (isZoomPhoneInitial || isBundleInitial) break;
  }
  let filterTypes = [];
  if (isZoomPhoneInitial) {
    filterTypes = [...BUNDLE_WITH_ZP_BASE_PLAN_TYPES];
  } else if (isBundleInitial) {
    filterTypes = [planTypes.ZOOM_PHONE];
  }
  //filter repeat basePlan && phonePlan
  initialPlans.forEach(plan => {
    if (baseMeetingTypeList.includes(plan.type)) {
      filterTypes.push(...baseMeetingTypeList);
    }
    if (plan.type === planTypes.ZOOM_PHONE &&
      plan.sub_type !== PBX_SUB_TYPES.BASE) {
      filterTypes.push(planTypes.ZOOM_PHONE);
    }
  });
  filterTypes.push(planTypes.ZOOM_ONE_BUNDLE, planTypes.ZOOM_UNITED, planTypes.CUSTOM_AVATARS, planTypes.ZOOM_PHONE$ZPA, planTypes.ZOOM_PHONE$ZPI, planTypes.ZOOM_PHONE_HARDWARE, planTypes.ZOOM_PHONE$ADDITIONAL);
  //zp and bundlePlan cannot exist at the same time
  pastPlans = pastPlans.filter(item => !filterTypes.includes(planTypes[item.semanticType]));

  function filterByTypePriority(arr, typeZp = [planTypes.ZOOM_PHONE], typeBundle = [...BUNDLE_WITH_ZP_BASE_PLAN_TYPES]) {
    let hasKeptType = false;
    return arr.filter(item => {
      if (typeZp.includes(planTypes[item.semanticType]) || typeBundle.includes(planTypes[item.semanticType])) {
        if (!hasKeptType) {
          hasKeptType = true;
          return true;
        }
        return false;
      }
      return true;
    });
  }
  //zp and bundlePlan cannot exist at the same time
  pastPlans = filterByTypePriority(pastPlans);
  if(pastPlans.length ===0) return pastPlans;
  if (pageConfig.modalFrom === 'client') {
    return [];
  }
  //meetingPlan has the highest priority
  const sortMeetingHighPriority = (a, b) => {
    const aPriority = baseMeetingTypeList.includes(planTypes[a.semanticType]) ? 0 : 1;
    const bPriority = baseMeetingTypeList.includes(planTypes[b.semanticType]) ? 0 : 1;
    return aPriority - bPriority;
  };
  return pastPlans.slice(0, 3).sort(sortMeetingHighPriority) || [];
};

function loadDefaultTargetPlanByQuery(planMapFlat) {
  // add target plan to cart
  let { from, period = BILLING_CYCLE.ANNUAL, quantity = 1 } = pageConfig;
  quantity = Number.parseInt(quantity) || 1;
  // addon plan categories
  const { category_codes = [], fromType } = planQueryParser(from);
  // add all search addon plans to cart
  category_codes.forEach((code) => {
    let quantity_ = code === category_codes[0] ? quantity : 1;
    addToCartByCategoryAndBillingCycle(planMapFlat, fromType, code, period, quantity_, (plan) => {
      // for biz plus default license
      if (
        isBizPlusContext &&
        (zoneBundleUtils.isBizPlusByCategory(code) || zoneBundleUtils.isBizPlusByCategory(plan?.category))
      ) {
        return ZOOM_MEETING_PRO_MIN_LICENSE;
      }

      if (isEduSchCmpPlusContext && zoneBundleUtils.isEduPlusByCategory(code)) {
        return ZOOM_MEETING_EDU_PLUS_MIN_LICENSE;
      }

      return quantity_;
    });
  });
}

const loadDefaultDependentPlanByQuery = (planMapFlat) => {
  const { from, period = BILLING_CYCLE.ANNUAL, plan = BASE_PLAN_SUB_TYPES.PRO } = pageConfig;
  const selectedPlans = filter(planMapFlat, (p) => p?.cartInfo?.selected_number > 0);
  const addPlanType = getPlanTypeByCategory(from);

  const targetPlan = find(selectedPlans, (p) => p.type === addPlanType) || {};
  const dependPlanTypeList = get(targetPlan, 'dependBasePlanTypeList', []);
  const dependTargetPlan = find(selectedPlans, (p) => includes(dependPlanTypeList, p.type));

  // * NN buy edu phone/webinar/zooms need add meeting edu as base plan
  if (
    window.$context.is.edu &&
    [...ZOOM_EDUCATION_INDIVIDUAL_PLAN_TYPES, ...ZOOM_EDUCATION_OPTIONAL_PLAN_TYPES].includes(targetPlan.type)
  ) {
    addBasePlanByTargetAddonPlan(
      planMapFlat,
      targetPlan,
      BASE_PLAN_SUB_TYPES.EDUCATION,
      period,
      getPlanTypeByCategory(plan),
      isBizPlusContext && ZOOM_MEETING_PRO_MIN_LICENSE,
    );
  } else if ([ZOOM_MEETING_SUB_TYPES.ZONE_EDU_PLUS, ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP].includes(plan)) {
    addDependBasePlan(planMapFlat, targetPlan);
  } else if (
    webinarSingleUseAllowed &&
    (period === BILLING_CYCLE.ONE_TIME || targetPlan?.billing_cycle === BILLING_CYCLE.ONE_TIME) &&
    addPlanType === planTypes.WEBINAR &&
    WEBINAR_ONE_TIME_CAPACITY.includes(targetPlan?.capacity)
  ) {
    addWebinarOneTimePsoRelatedPlan(planMapFlat, targetPlan);
  } else {
    addBasePlanByTargetAddonPlan(
      planMapFlat,
      targetPlan,
      dependTargetPlan?.type,
      period,
      getPlanTypeByCategory(plan),
      isBizPlusContext && ZOOM_MEETING_PRO_MIN_LICENSE,
      // limit scope for case like 'increase with large meeting', add meetingSubCate as base plan
      targetPlan.type == planTypes.LARGE_MEETING && [ZOOM_MEETING_SUB_TYPES.BIZ].includes(plan) && dependPlanTypeList?.includes(planTypes.ZOOM_MEETING) ? plan : ''
    );
  }
  addBasePlanToStandAlone(planMapFlat, targetPlan, plan, period);

  // when the current account to add zone bundle plan, need check if add pbx base plan
  if (isProPlusContext || isBizPlusContext) {
    addDefaultPbxBasePlanToShoppingCartByQuery(planMapFlat);
  }

  return planMapFlat;
};

export const loadInitialPlanFlag = (planMapFlat) => {
  const initialPlanCodes = planMapFlat.filter((item) => item.cartInfo?.selected_number > 0).map(item => item.originPlanCode || item.plan_code) || [];
  store.commit('setInitialPlanCodes', initialPlanCodes);
};

const checkDependentPlan = (planMapFlat, selectedPlans, targetPlan) => {
  const { dependBasePlanTypeList = [] } = targetPlan;
  const basePlan = selectedPlans.find(
    (item) => dependBasePlanTypeList.length && dependBasePlanTypeList.includes(item.type),
  );
  if (basePlan) return planMapFlat;
  const defaultType = dependBasePlanTypeList[0],
    defaultPeriod = pageConfig.period || BILLING_CYCLE.ANNUAL;
  planMapFlat.find((item) => {
    if (item.type === defaultType && item.billing_cycle === defaultPeriod) {
      addToCart(item, 1);
      return true;
    }
    return false;
  });
};

function loadDefaultSelectByQuery(planMapFlat) {
  const hasSelectedPlan = checkSelectedPlan(planMapFlat);
  if (hasSelectedPlan && window.$context.is.fromPersistentCart) {
    loadInitialPlanFlag(planMapFlat);
  }
  if (hasSelectedPlan) return planMapFlat;

  const { init_categories } = pageConfig;

  if (init_categories) {
    loadWinbackByQuery(planMapFlat);
    const selectedPlans = filter(planMapFlat, (p) => p?.cartInfo?.selected_number > 0);
    selectedPlans.forEach((item) => checkDependentPlan(planMapFlat, selectedPlans, item));
  }

  if (!checkSelectedPlan(planMapFlat)) {
    loadDefaultTargetPlanByQuery(planMapFlat);
    loadDefaultDependentPlanByQuery(planMapFlat);
    loadInitialPlanFlag(planMapFlat)
  }

  addVendorProduct(planMapFlat)

  return planMapFlat;
}

export function addDefaultPbxBasePlanToShoppingCartByQuery(planMapFlat) {
  //todo risk
  const callingPlans = computedUnlimitedCallingPlans(planMapFlat).concat(computedPbxMeteredPlans(planMapFlat));
  const existCallingPlan = _.some(callingPlans, (p) => p?.cartInfo?.selected_number > 0);

  // exist calling plan(pro_plus/biz_plus/pbx) calling plan, but not have pbx base plan
  if (existCallingPlan) {
    const pbxBasePlans = computedPbxBasePlans(planMapFlat);
    const existPbxBasePlan = _.some(pbxBasePlans, (p) => p?.cartInfo?.selected_number > 0);

    if (!existPbxBasePlan) {
      _.forEach(planMapFlat, (plan) => {
        plan?.is_payg && addToCart(plan, 1);
      });
    }
  }

  return planMapFlat;
}

function loadDefaultByQueryWhenCartIsEmpty(planMapFlat) {
  let { plan = BASE_PLAN_SUB_TYPES.PRO, period = BILLING_CYCLE.ANNUAL, from } = pageConfig;
  const hasSelectedPlan = checkSelectedPlan(planMapFlat);

  if (hasSelectedPlan) return planMapFlat;

  let planType = getPlanTypeByCategory(plan);

  // In order to solve some undefined category types,
  // such as z1s, which cause planType to not be found, a pro can be loaded by default.
  if (isEmptyVal(planType)) {
    plan = BASE_PLAN_SUB_TYPES.PRO;
    planType = getPlanTypeByCategory(plan);
  }

  // patch for marketing campaign cases (coupon expired, can not init shopping cart with target promotion plans)
  if (isFromMarketingCampaign()) {
    // For zoom phone cases (need special logic to init shopping cart)
    if (planType === planTypes.ZOOM_PHONE && !from) {
      return preloadWithNoActiveCouponCampaignUtils[planTypes.ZOOM_PHONE]?.(planMapFlat);
    }
  }

  addToCartByCategoryAndBillingCycle(planMapFlat, planType, plan, period, 1);
  planType === planTypes.VIDEO_SDK && addToCartByType(planMapFlat, planType, 1);
  loadInitialPlanFlag(planMapFlat);

  return planMapFlat;
}

const filterDisabledPlans = (allPlanResult = {}) => {
  const { disablePlanCodeList = [], disablePlanCategoryList = [] } = allPlanResult;

  return (planMapFlat = []) => {
    return filter(planMapFlat, (p) => {
      return (
        includes(disablePlanCodeList, p?.plan_code) === false &&
        includes(disablePlanCategoryList, p?.parent_category) === false
      );
    });
  };
};

// isFreeTrialAccount
function loadFreeTrialAccount(planMapFlat) {
  const hasSelectedPlan = planMapFlat.find((item) => item.cartInfo.selected_number > 0);
  if (!hasSelectedPlan) {
    // Add Biz
    const { period = 'annual' } = pageConfig;
    const bizPlans = planMapFlat.filter((item) => item.category === 'biz');
    const bizPlan = bizPlans.find((item) => item.billing_cycle === period) || bizPlans[0];
    bizPlan.cartInfo.selected_number = 10;
    // Add Webinar
    const webinar500Plans = planMapFlat.filter((item) => item.category === 'webinar500');
    const webinar500Plan = webinar500Plans.find((item) => item.billing_cycle === period) || webinar500Plans[0];
    webinar500Plan.cartInfo.selected_number = 10;
    // Add Large meeting
    const large500Plans = planMapFlat.filter((item) => item.category === 'large500');
    const large500Plan = large500Plans.find((item) => item.billing_cycle === period) || large500Plans[0];
    large500Plan.cartInfo.selected_number = 10;
    return planMapFlat;
  }
  return planMapFlat;
}

const initShoppingCartForBuyNow = async (state) => {
  const { persist } = state;
  // load data
  const { planMap: result } = await getAllProductInfo();
  const { result: capacityList } = await capacityConfig({ flowType: flowTypes.buyNow });

  simulateSingleUseProPlan(result);
  const buyNowLoader = new PageLoader(result);
  buyNowLoader.decorate('plansDataMapper', plansDataMapper);
  buyNowLoader.decorate('filterDisabledPlans', filterDisabledPlans(result));
  buyNowLoader.decorate('filterCapacity', filterCapacity(capacityList));
  buyNowLoader.decorate('loadByPersist', loadSelectByPersist(persist));
  buyNowLoader.decorate('loadDefaultPlansByCartId', loadDefaultPlansByCartId);
  buyNowLoader.decorate('loadDefaultSelectByCoupon', loadDefaultPlansByPreloadCoupon());
  buyNowLoader.decorate('loadDefaultPlansByPartnerReferral', loadDefaultPlansByPartnerReferral);
  buyNowLoader.decorate('loadByShoppingCart', loadByShoppingCart);
  buyNowLoader.decorate('loadDefaultSelectByQuery', loadDefaultSelectByQuery);
  buyNowLoader.decorate('loadDefaultByQueryWhenCartIsEmpty', loadDefaultByQueryWhenCartIsEmpty);
  buyNowLoader.decorate('loadSelectByPersistAfterSwitch', loadSelectByPersistAfterSwitch);

  const data = await buyNowLoader.dispatch();

  // FREE TRIAL - check error
  freeTrialIneligibleCheck();

  return {
    allPlanMap: result,
    planMapFlat: data,
  };
};

const initShoppingCartForBasicToPro = async (state) => {
  const { persist } = state;
  // load data
  const { planMap: result } = await getAllProductInfo();
  simulateSingleUseProPlan(result);
  const subscriptions = await getAccountSubscriptions();
  const buyNowLoader = new PageLoader(result);
  buyNowLoader.decorate('plansDataMapper', (plans) => plansDataMapper(plans));
  buyNowLoader.decorate('filterDisabledPlans', filterDisabledPlans(result));
  buyNowLoader.decorate('loadByPersist', loadSelectByPersist(persist));
  buyNowLoader.decorate('loadDefaultPlansByCartId', loadDefaultPlansByCartId);
  buyNowLoader.decorate('loadDefaultSelectByCoupon', loadDefaultPlansByPreloadCoupon());
  buyNowLoader.decorate('loadDefaultPlansByPartnerReferral', loadDefaultPlansByPartnerReferral);
  buyNowLoader.decorate('loadByShoppingCart', loadByShoppingCart);
  if (pageConfig.isFreeTrialAccount) {
    buyNowLoader.decorate('loadFreeTrialAccount', loadFreeTrialAccount);
  } else {
    buyNowLoader.decorate('loadDefaultSelectByQuery', loadDefaultSelectByQuery);
  }
  buyNowLoader.decorate('loadDefaultByQueryWhenCartIsEmpty', loadDefaultByQueryWhenCartIsEmpty);
  buyNowLoader.decorate('loadSelectByPersistAfterSwitch', loadSelectByPersistAfterSwitch);
  const data = await buyNowLoader.dispatch();

  // FREE TRIAL - check error
  freeTrialIneligibleCheck();

  const [billngConfig, invoiceData, pastPlans] = await Promise.all([
    billingConfig$Cache(),
    getOpenInvoiceState(),
    requestPastPlans(data,subscriptions),
  ]);
  const freeTrialPlans = getAccountFreeTrialPlans(subscriptions, data, billngConfig)

  return {
    allPlanMap: result,
    planMapFlat: data,
    subscriptions,
    freeTrialPlans,
    invoiceData,
    pastPlans
  };
};

async function checkFreetrialAssignInfo() {
  const billngConfig = await billingConfig$Cache()
  const {
    assignedUserCount = 0,
    assignedWbnUserCount = 0,
    assignedLmtUserCount = 0,
  } = (billngConfig?.result || {});

  function freetrialAccountUpgradeLicenseDialog(...args) {
    if(window.newBillingConfig.isPaid) {
      return BillingMessageBox.confirm(
        translation('billing.planform.zoom_meeting.less_than_assigned_number_tips', args),
        translation('billing.cancel_title_sorry_to_see_you_go'),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: translation('billing.success.go_to_user_management'),
          cancelButtonText: translation('billing.common.cancel'),
        },
      ).then(() => {
        formJump('/account/user', 'GET');
        return Promise.reject();
      });
    }
    return BillingMessageBox.alert(
      translation('billing.planform.zoom_meeting.less_than_assigned_number_tips_for_expire', args),
      translation('billing.cancel_title_sorry_to_see_you_go'),
      {
        dangerouslyUseHTMLString: true,
        confirmButtonText: translation('billing.got_it'),
      },
    ).then(() => {
      return Promise.reject();
    });
  }

  const currentMeetingCount = plansof(store.getters.getSelectedPlans).type(planTypes.ZOOM_MEETING).sum('license');
  const currentWebinar500Count = plansof(store.getters.getSelectedPlans).type(planTypes.WEBINAR).capacity(500).sum('license');
  const currentLarge500Count = plansof(store.getters.getSelectedPlans).type(planTypes.LARGE_MEETING).capacity(500).sum('license');

  if (currentMeetingCount < assignedUserCount) {
    return freetrialAccountUpgradeLicenseDialog(assignedUserCount, assignedUserCount - currentMeetingCount);
  }
  if (currentWebinar500Count < assignedWbnUserCount) {
    return freetrialAccountUpgradeLicenseDialog(assignedWbnUserCount, assignedWbnUserCount - currentWebinar500Count);
  }
  if (currentLarge500Count < assignedLmtUserCount) {
    return freetrialAccountUpgradeLicenseDialog(assignedLmtUserCount, assignedLmtUserCount - currentLarge500Count);
  }
  return Promise.resolve();
}

export class BaseCheckoutForSubmit {
  async generateCheckoutParams() {
    const getters = store.getters;
    const isARLChecked = getters.isARLChecked;
    const addressInfo = getters.addressInfo;
    const account = getters.account;

    const { apmInfo } = store.getters;
    const { couponCode = '' } = getters.couponState;
    // soft bundle use coupon drive (old version)
    const fromZoomBundleJointsale = getters.eligiblePartnerReferOffer && !!getters.partnerUseInSoftBundle && !getters.softBundleUseByPriceEngine;
    let { paymentResponse, paymentGateway } = getters.paymentMethodInfo;
    const partnerReferParams = getPartnershipParams();
    if (apmInfo.isApm) {
      paymentResponse = JSON.stringify({
        integrationType: APM,
      });
    }
    const audioCountriesParams = getAudioCountriesParams(store);
    const {
      healthcareEligible,
      healthcareInfo: { businessCountry },
    } = getters;
    const targetUserIdParams = getTargetUserIdParam();

    let sellerId = '';
    const deskphone = getters.getSelectedPlans.filter(item => item.isVendorProduct).map(item => {
      sellerId = item.__originData?.sellerId;
      return {
        itemId: item.plan_code,
        quantity: item.cartInfo.selected_number
      }
    })

    const params = {
      taxInfo: getters.taxInfo,

      contact: cloneDeep([
        _.omit(removeEmptyValue(getters.billToContact), ['shippingForm', 'shippingSameWithContact']),
        _.omit(removeEmptyValue(getters.soldToContact), ['shippingForm', 'shippingSameWithContact']),
      ]),
      paymentInfo: { paymentResponse, paymentGateway },
      orderData: {
        planList: getters.selectedPlanListPayLoad,
        coupon: { fromCampaignLink: getters.fromCampaignLink, fromZoomBundleJointsale, code: couponCode  },
        ...(getters.referralCode ? {
          referralData: {
            referralCode: getters.referralCode,
          }
        } : {})
      },
      extension: {
        billingChannel: 'billing_page',
        usageType: addressInfo?.usageType,
        useCase: addressInfo?.useCase,
        otherUseCase: addressInfo?.otherUseCase,
        scheduledEmailId: window.$cookie.get(ABANDON_CART_EMAIL_COOKIE_KEY),
        age: account?.age,
        ...partnerReferParams,
        ...(pageConfig.mid ? { meetingId: pageConfig.mid } : {}),
        ...(!audioCountriesParams ? {} : { tollFreeProfileData: audioCountriesParams }),
        ...(healthcareEligible ? { hipaaCompliant: true, baaCountry: businessCountry } : {}),
        ...(isARLChecked ? { isARLChecked: true } : {}),
        ...targetUserIdParams
      },
      agreements: {},
    };

    if (deskphone.length > 0) {
      let defaultEcmInfo = null;
      const countryMap = getters.enCountryMap || getters.countryMap;
      const { country, state, city, address1, zip, phone } = getters.shippingAddressGetter;

      try {
        const { result } = await getDefaultEcmInfo(country, state);
        defaultEcmInfo = result;
      } catch (error) {
        logger.error('getDefaultEcmInfo error', error);
      }

      params.ecommSellerOrderData = {
        address: [{
          firstName: account.firstName,
          lastName: account.lastName,
          companyName: addressInfo.companyName,
          phone: phone || addressInfo.phone,
          country: new Enums(countryMap)[country] || country,
          state: new Enums(US_short)[state] || state,
          city: city,
          address1: address1,
          zip: zip,
        }],
        items: deskphone,
        tax: [{
          sellerId,
          taxExemptStatus: defaultEcmInfo?.exemptStatus || getters.taxInfo.ttrTaxExempt,
          certificateId: defaultEcmInfo?.ecmCertificateId || getters.certificateId,
          ecmExemptionId: defaultEcmInfo?.ecmExemptionId || null,
          createTime: defaultEcmInfo?.createTime || null,
        }],
      }
    }

    addParamsIfNeedUseVerification(params.extension);

    // for agreements
    if (Reflect.has(getters, 'agreements')) {
      if (getters.agreements.regionTypes !== regionTypesEnum.NOLIMITED_REGIONS) {
        params.agreements.isMarketingReview = !!getters.agreements.marketingReview;
      }
    }
    const preAssignPhoneNumber = getPreAssignPhoneNumber();
    if (!isEmptyVal(preAssignPhoneNumber)) {
      params.extension.preAssignPhoneNumber = preAssignPhoneNumber;
    }

    if (addressInfo?.isForEdu) {
      params.extension.coppa = addressInfo.coppa.join(',');

      if (addressInfo?.usageType !== 'business' && !addressInfo?.companyName) {
        const { orgName = '', orgCount = '' } = addressInfo;
        params.contact.forEach((c) => {
          c.companyName = orgName;
          c.employeeCount = orgCount;
        });
      }
    }

    params.orderSummary = {
      orderSummaryFields: getOrderSummaryFields(getters),
    };

    return params;
  }
  preparePaymentData = async (params) => {
    const requestBodyData = await this.generateCheckoutParams();
    requestBodyData.isPreview = true;
    return generateOnSessionSignature({ ...params, requestBodyData: JSON.stringify(requestBodyData) });
  };
}

class CheckOutForBuyNowSubmit extends BaseCheckoutForSubmit {
  submit = async () => {
    const {
      apmInfo,
      agreements: { regionTypes = regionTypesEnum.NOLIMITED_REGIONS },
    } = store.getters;
    // LOOKUP router
    const lookupRouterParams = getLookupRouterParams();

    if (apmInfo.isApm) {
      const eventResult = await pollingEventStatus({ rps: true });
      store.commit('setTransactionId', eventResult?.uniqueKey);
      store.commit('setPreviewKey', eventResult?.previewKey);
      const successParams = {
        ...lookupRouterParams,
        integrationType: APM,
        apmMethodName: apmInfo.apmPaymentMethodName,
      };
      apmInfo.apmPaymentMethodName === WISE
        ? gotoWiseSuccessPage({ wiseStateValue: apmInfo.wiseStateValue })
        : gotoSuccessPage(successParams);
      return {
        eventResult,
      };
    }
    const loggedIn = window.$context?.is?.loggedIn;
    const params = await this.generateCheckoutParams();
    // just avoid place order api is fail and user have been created,
    // so when the customer refresh page, will recognized free account, should call free upgrade api

    lockAndCancelTaxApi();

    let eventResult;

    eventResult = await (loggedIn
      ? freeUpgrade(params)
      : buySubscription({
          ...lookupRouterParams,
          ...params,
        }));

    if (![TRIAL_SUCCESS_CODE].includes(eventResult?.result)) {
      eventResult = await pollingEventStatus({ rps: true });
    }

    store.commit('setTransactionId', eventResult?.uniqueKey);
    store.commit('setPreviewKey', eventResult?.previewKey);

    const successParams = loggedIn ? undefined : { coppa: params?.extension?.coppa, ...lookupRouterParams, };

    // GDPR params
    let GDPRParams = {};
    if (Reflect.has(params, 'agreements') && Reflect.has(params, 'contact')) {
      // Euro countries
      if (regionTypes === regionTypesEnum.COUNTRY_EUROPEAN_ECONOMIC_AREA) {
        const enableMarketingReviewEnumMap = {
          DISABLE: 0,
          ENABLE: 1,
        };
        GDPRParams = {
          email: params.contact[0]?.email,
          source: 'USER_SIGNUP',
          opt: params.agreements.isMarketingReview
            ? enableMarketingReviewEnumMap.ENABLE
            : enableMarketingReviewEnumMap.DISABLE,
        };
      }
    }

    if (eventResult?.result === TRIAL_SUCCESS_CODE) {
      gotoTrialSuccessPage({ ...successParams, GDPRParams });
    } else {
      gotoSuccessPage({ ...successParams, GDPRParams });
    }

    return {
      eventResult,
    };
  };
}

class CheckOutForBasic2ProSubmit extends BaseCheckoutForSubmit {
  submit = async () => {
    const { withCcAccount, apmInfo } = store.getters;

    if (apmInfo.isApm) {
      const eventResult = await pollingEventStatus({ rps: true });

      const successParams = {
        integrationType: APM,
        apmMethodName: apmInfo.apmPaymentMethodName,
      };
      const trackingName = withCcAccount ? 'Free w/ CC Upgrade' : 'Free w/o CC Upgrade';
      apmInfo.apmPaymentMethodName === WISE
        ? gotoWiseSuccessPage({ wiseStateValue: apmInfo.wiseStateValue, flowType: trackingName })
        : gotoSuccessPage(successParams);

      return {
        eventResult,
        trackingName,
      };
    }

    const eventResult = await (withCcAccount ? this.submitForFreeWithCc() : this.submitForFreeWithOutCc());
    successTempEventStatus.setValue(eventResult);

    if (eventResult?.result === TRIAL_SUCCESS_CODE) {
      gotoTrialSuccessPage({});
    } else {
      upgradeSuccessPage();
    }

    return {
      eventResult,
      trackingName: withCcAccount ? 'Free w/ CC Upgrade' : 'Free w/o CC Upgrade',
    };
  };
  submitForFreeWithOutCc = async () => {
    const params = await this.generateCheckoutParams();
    let eventResult;
    if (store.getters.isOnlineFreeTrailAccount) {
      eventResult = await purchasePlan({ ...params, bizType: PLAN_UPGRADE_BIZ_TYPE.PLAN_PURCHASE });
    } else {
      eventResult = await freeUpgrade(params);
    }
    if (eventResult?.result === TRIAL_SUCCESS_CODE) return Promise.resolve(eventResult);
    return pollingEventStatus({ rps: true });
  };
  submitForFreeWithCc = async () => {
    const { orderData, extension, orderSummary = {}, contact, ecommSellerOrderData } = await this.generateCheckoutParams();
    const params = { orderData, extension, orderSummary, contact, ecommSellerOrderData };
    let eventResult;
    if (store.getters.isOnlineFreeTrailAccount) {
      eventResult = await purchasePlan({ ...params, bizType: PLAN_UPGRADE_BIZ_TYPE.PLAN_PURCHASE });
    } else {
      eventResult = await freeUpgrade(params);
    }
    if (eventResult?.result === TRIAL_SUCCESS_CODE) return Promise.resolve(eventResult);
    return pollingEventStatus({ rps: true });
  };
}

const preCheckBuyNow = async () => {
  await preCheckForPbx();
  await beforeCheckForCoupon();
  await checkCountriesRegionsOption();
};

const resolveView = () => VIEWS.CONFIG;

const preCheckForSwitchPlan = async (oldPlanList, newPlanList, soldToCountry) => {
  await preCheckPartnerRefer(oldPlanList, newPlanList, soldToCountry);
};

const beforeContinueForPreCheck = async () => {
  await checkBizPlusLicensePromise();
  await preCheckZoneProPlusForBuyNow();
  await checkZoneEduPlusLicense();
};

const beforeInitForPreCheck = async () => {
  await beforeInitPageCheckForCoupon();
};

export default {
  [flowTypes.buyNow]: class extends Flow {
    view() {
      return resolveView();
    }
    beforeInit() {
      return beforeInitForPreCheck();
    }
    init() {
      return initShoppingCartForBuyNow(...arguments);
    }
    beforeContinue() {
      return beforeContinueForPreCheck();
    }
    beforeUpdate() {
      return preCheckForSwitchPlan(...arguments);
    }
    beforeSubmit() {
      return preCheckBuyNow();
    }
    submit(submitParams) {
      return new CheckOutForBuyNowSubmit().submit(submitParams);
    }
    preparePaymentData(params) {
      return new CheckOutForBuyNowSubmit().preparePaymentData(params);
    }
  },
  [flowTypes.basic2pro]: class extends Flow {
    view() {
      const compoundFreeWithccPlan = [planTypes.ZONE_BASIC_PLUS, planTypes.ZONE_PPM];
      if (
        compoundFreeWithccPlan.includes(getPlanTypeByCategory(pageConfig.plan)) &&
        pageConfig.accountType === AccountType.ACCOUNT_FREE_WITH_CC
      ) {
        return VIEWS.COMPOUND;
      }
      return VIEWS.CONFIG;
    }
    beforeInit() {
      return beforeInitForPreCheck();
    }
    init() {
      return initShoppingCartForBasicToPro(...arguments);
    }
    async beforeContinue() {
      if (pageConfig.isFreeTrialAccount) {
        await checkFreetrialAssignInfo();
      }
      return beforeContinueForPreCheck();
    }
    beforeUpdate() {
      return preCheckForSwitchPlan(...arguments);
    }
    beforeSubmit() {
      return preCheckBuyNow();
    }
    submit(submitParams) {
      return new CheckOutForBasic2ProSubmit().submit(submitParams);
    }
    preparePaymentData(params) {
      return new CheckOutForBasic2ProSubmit().preparePaymentData(params);
    }
  },
};
